import { TarjetaModel } from "./tarjeta.model";

export class CiudadanoModel {
  id: number;
  nombre: string;
  apellidos: string;
  telefono: number;
  correoElectronico: string;
  idZona: number = null;
  numeroCatastro: string;
  direccion: string;
  codigoPostal: number;
  municipio: string;
  provincia: string;
  comunidadAutonoma: string;
  estadoValidacion: number = 0;
  empresa: number;
  fechaCreacion: Date;

  tarjetas: TarjetaModel[] = [];

  constructor() { }
}
